import React from 'react';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { useUserTourStore } from 'stores/userTourStore';
import { useNavigate } from 'react-router';
import { UserTourTooltip } from './UserTourToolTip';

export default function UserTour() {
  const navigate = useNavigate();
  const { run, steps, stepIndex, resetTour, setRun, setStepIndex } = useUserTourStore();
  const handleCallback = (data) => {
    const { type, index, action, step, status } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status) || action === ACTIONS.CLOSE) {
      resetTour();
      return;
    }

    if (type === EVENTS.STEP_AFTER) {
      const isPrev = action === ACTIONS.PREV;
      if (index === steps.length - 1 && !isPrev) {
        resetTour();
        return;
      }

      const nextIndex = index + (isPrev ? -1 : 1);
      const nextRoute = isPrev ? step?.data?.previous : step?.data?.next;

      if (nextRoute && window.location.pathname !== nextRoute) {
        setRun(false);
        setStepIndex(nextIndex);
        navigate(nextRoute);
      } else {
        setStepIndex(nextIndex);
      }
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      stepIndex={stepIndex}
      continuous
      showSkipButton
      callback={handleCallback}
      styles={{
        options: {
          arrowColor: 'white',
          textColor: 'white',
          spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
          overlayColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9999,
        },
      }}
      tooltipComponent={UserTourTooltip}
    />
  );
}
